import { module } from 'modujs';
import gsap from 'gsap';
import { SplitText } from '../vendor/gsap-esm/SplitText';
gsap.registerPlugin(SplitText);

export default class extends module {
  constructor(m) {
    super(m);
  }

  init() {
    this.DOM = {
      view: this.el,
    };
    this.FX = {
      lines: new SplitText(this.DOM.view, {
        type: 'lines',
        linesClass: 'css-line',
      }),
      words: new SplitText(this.DOM.view, {
        type: 'words',
        wordsClass: 'css-word',
      }),
    };
  }
}
